// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analytics-dashboard {
    font-family: "DM Sans", sans-serif;
    margin-top: 30px;
}

.main-loading-spinner {
    font-size: 40px;
    color: #5616ea;
}

.analytics-title h1 {
    text-align: left;
    color: #333;
    margin-bottom: 30px;
}

.selection-container {
    display: flex;
    gap: 15px;
    margin-bottom: 20px;
    max-width: 800px;
}

.date-picker-container {
    display: flex;
    gap: 15px
}

.MuiOutlinedInput-root {
    background-color: white;
}

.actions {
    margin-bottom: 20px;
}

.kpi-container {
    display: flex;
    gap: 20px;
    margin-bottom: 15px;
}

/* --- Message usage KPI with hover tooltip --- */
.kpi-usage-metric {
    /* extra styles specific to the messages-used card */
}

.kpi-usage-limit {
    font-size: 18px;
    font-weight: 400;
    color: #9ca3af;
}

.kpi-usage-tooltip {
    position: fixed;
    transform: translateX(-50%);
    background: linear-gradient(135deg, #5616ea 0%, #7c3aed 100%);
    color: #fff;
    border-radius: 10px;
    padding: 14px 16px;
    min-width: 260px;
    max-width: 340px;
    z-index: 99999;
    box-shadow: 0 8px 24px rgba(86, 22, 234, 0.35), 0 4px 12px rgba(0, 0, 0, 0.15);
    animation: kpiTooltipFadeIn 0.15s ease;
}

@keyframes kpiTooltipFadeIn {
    from { opacity: 0; transform: translateX(-50%) translateY(4px); }
    to { opacity: 1; transform: translateX(-50%) translateY(0); }
}

.kpi-usage-tooltip-title {
    font-size: 12px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.85);
    text-transform: uppercase;
    letter-spacing: 0.04em;
    margin-bottom: 2px;
}

.kpi-usage-tooltip-desc {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.75);
    margin-bottom: 10px;
    line-height: 1.4;
}

.kpi-usage-tooltip-subtitle {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.6);
    margin-bottom: 10px;
}

.kpi-usage-tooltip-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 7px;
}

.kpi-usage-tooltip-row:last-child {
    margin-bottom: 0;
}

.kpi-usage-tooltip-name {
    font-size: 13px;
    font-weight: 500;
    color: #fff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 110px;
    flex-shrink: 0;
}

.kpi-usage-tooltip-bar-track {
    flex: 1 1;
    height: 6px;
    background-color: rgba(255, 255, 255, 0.25);
    border-radius: 3px;
    overflow: hidden;
    min-width: 50px;
}

.kpi-usage-tooltip-bar-fill {
    height: 100%;
    background-color: #fff;
    border-radius: 3px;
    transition: width 0.4s ease;
}

.kpi-usage-tooltip-bar-full {
    background-color: #ef4444;
}

.kpi-usage-tooltip-values {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.85);
    white-space: nowrap;
    flex-shrink: 0;
    text-align: right;
    min-width: 40px;
    margin-left: auto;
}

.charts-parent-container {
    display: flex;
    width: 100%;
    gap: 20px;
    margin-top: 20px;
    margin-bottom: 20px;
}

.charts-container {
    width: 49.5%;
}

.charts-title {
    color: #5616ea;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 15px;
}

.charts-graph {
    background-color: rgb(255, 255, 255);
    border-radius: 10px;
    padding: 12px;
    height: 350px;
    border: 1px solid #e5e7eb;
}

.chat-interface-container {
    display: flex;
    width: 100%;
    height: 750px;
    border: 1px solid #ddd;
    border-radius: 10px;
    overflow: hidden;
}

.chat-list-container {
    width: 30%;
    max-width: 350px;
    min-width: 200px;
    background-color: #f5f5f5;
    overflow-y: auto;
    border-right: 1px solid #ddd;
    display: flex;
    flex-direction: column;
}

/* For Webkit Browsers (Chrome, Safari, Edge) */
.chat-list-container::-webkit-scrollbar {
    width: 8px;
}

.chat-list-container::-webkit-scrollbar-track {
    background: #f5f5f5;
    border-radius: 4px;
}

.chat-list-container::-webkit-scrollbar-thumb {
    background: #bbb;
    border-radius: 4px;
}

.chat-list-container::-webkit-scrollbar-thumb:hover {
    background: #999;
}

/* For Firefox */
.chat-list-container {
    scrollbar-width: thin;
    scrollbar-color: #bbb #f5f5f5;
}

.chat-list-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
}

.chat-list-last-message {
    margin-top: 5px;
    font-size: 14px;
    color: #666;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.chat-session.selected .chat-list-last-message {
    color: #ffffff;
}

.chat-session {
    padding: 10px;
    padding-top: 15px;
    padding-bottom: 15px;
    cursor: pointer;
    border-bottom: 1px solid #ddd;
    background-color: rgb(252, 252, 252);
    transition: background-color 0.2s ease;
}

.chat-session:hover {
    background-color: #e0e0e0;
}

.chat-session.selected {
    background-color: #5616ea;
    color: #ffffff;
}

.chat-history-container {
    flex: 1 1;
    padding: 15px;
    padding-top: 20px;
    padding-bottom: 20px;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    overflow-y: auto;
}

/* For Webkit Browsers (Chrome, Safari, Edge) */
.chat-history-container::-webkit-scrollbar {
    width: 8px;
}

.chat-history-container::-webkit-scrollbar-track {
    background: #f5f5f5;
    border-radius: 4px;
}

.chat-history-container::-webkit-scrollbar-thumb {
    background: #bbb;
    border-radius: 4px;
}

.chat-history-container::-webkit-scrollbar-thumb:hover {
    background: #999;
}

/* For Firefox */
.chat-history-container {
    scrollbar-width: thin;
    scrollbar-color: #bbb #f5f5f5;
}


.chat-history {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.chat-message {
    display: flex;
}

.user-message {
    justify-content: flex-end;
}

.assistant-message {
    justify-content: flex-start;
}

.message-bubble {
    /* max-width: 70%; */
    padding: 10px;
    border-radius: 10px;
    word-wrap: break-word;
}

.user-message .message-bubble {
    background-color: #d1f0ff;
}

.no-chat-selected {
    text-align: center;
    color: #999;
    font-size: 18px;
    margin-top: auto;
    margin-bottom: auto;
}

.download-header-parent {
    display: flex;
    flex-direction: row;
    gap: 15px;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
}

.charts-title-download {
    color: #5616ea;
    font-size: 18px;
    font-weight: 600;
}

.download-chat-history-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    outline: none;
    padding: 8px;
    padding-top: 6px;
    padding-bottom: 6px;
    background-color: #5616ea;
    border: none;
    color: white;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.3s ease;
    box-shadow: 0 4px 14px rgba(0,0,0,0.1);
}

.download-chat-history-btn:hover {
    background-color: #4a14d6;
    transform: translateY(-1px);
}

.download-chat-history-btn:disabled {
    background-color: #c4c4c4;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

.download-chat-history-icon {
    font-size: 16px;
}

@media (max-width: 768px) {
    .selection-container {
        flex-direction: column;
    }

    .kpi-container {
        flex-wrap: wrap;
        justify-content: center;
    }

    .kpi-container > * {
        flex-grow: 1;
        flex-shrink: 1;
        flex-basis: calc(50% - 10px);
        box-sizing: border-box;
    }

    .charts-parent-container {
        flex-direction: column;
    }

    .charts-container {
        width: 100%;
    }

    .chat-list-container {
        width: 30%;
        max-width: 350px;
        min-width: 160px;
    }

    .chat-interface-container {
        height: 500px;
    }

    .charts-graph {
        background-color: rgb(255, 255, 255);
        border-radius: 10px;
        padding: 5px;
        height: 250px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/analytics.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA,iDAAiD;AACjD;IACI,oDAAoD;AACxD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,6DAA6D;IAC7D,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,8EAA8E;IAC9E,sCAAsC;AAC1C;;AAEA;IACI,OAAO,UAAU,EAAE,2CAA2C,EAAE;IAChE,KAAK,UAAU,EAAE,yCAAyC,EAAE;AAChE;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,WAAW;IACX,2CAA2C;IAC3C,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,SAAS;IACT,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;AAC1B;;AAEA,+CAA+C;AAC/C;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,6BAA6B;IAC7B,oCAAoC;IACpC,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA,+CAA+C;AAC/C;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,qBAAqB;IACrB,6BAA6B;AACjC;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,2DAA2D;IAC3D,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;QACf,uBAAuB;IAC3B;;IAEA;QACI,YAA0B;QAA1B,cAA0B;QAA1B,4BAA0B;QAC1B,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,UAAU;QACV,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,oCAAoC;QACpC,mBAAmB;QACnB,YAAY;QACZ,aAAa;IACjB;AACJ","sourcesContent":[".analytics-dashboard {\r\n    font-family: \"DM Sans\", sans-serif;\r\n    margin-top: 30px;\r\n}\r\n\r\n.main-loading-spinner {\r\n    font-size: 40px;\r\n    color: #5616ea;\r\n}\r\n\r\n.analytics-title h1 {\r\n    text-align: left;\r\n    color: #333;\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.selection-container {\r\n    display: flex;\r\n    gap: 15px;\r\n    margin-bottom: 20px;\r\n    max-width: 800px;\r\n}\r\n\r\n.date-picker-container {\r\n    display: flex;\r\n    gap: 15px\r\n}\r\n\r\n.MuiOutlinedInput-root {\r\n    background-color: white;\r\n}\r\n\r\n.actions {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.kpi-container {\r\n    display: flex;\r\n    gap: 20px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n/* --- Message usage KPI with hover tooltip --- */\r\n.kpi-usage-metric {\r\n    /* extra styles specific to the messages-used card */\r\n}\r\n\r\n.kpi-usage-limit {\r\n    font-size: 18px;\r\n    font-weight: 400;\r\n    color: #9ca3af;\r\n}\r\n\r\n.kpi-usage-tooltip {\r\n    position: fixed;\r\n    transform: translateX(-50%);\r\n    background: linear-gradient(135deg, #5616ea 0%, #7c3aed 100%);\r\n    color: #fff;\r\n    border-radius: 10px;\r\n    padding: 14px 16px;\r\n    min-width: 260px;\r\n    max-width: 340px;\r\n    z-index: 99999;\r\n    box-shadow: 0 8px 24px rgba(86, 22, 234, 0.35), 0 4px 12px rgba(0, 0, 0, 0.15);\r\n    animation: kpiTooltipFadeIn 0.15s ease;\r\n}\r\n\r\n@keyframes kpiTooltipFadeIn {\r\n    from { opacity: 0; transform: translateX(-50%) translateY(4px); }\r\n    to { opacity: 1; transform: translateX(-50%) translateY(0); }\r\n}\r\n\r\n.kpi-usage-tooltip-title {\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    color: rgba(255, 255, 255, 0.85);\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.04em;\r\n    margin-bottom: 2px;\r\n}\r\n\r\n.kpi-usage-tooltip-desc {\r\n    font-size: 12px;\r\n    color: rgba(255, 255, 255, 0.75);\r\n    margin-bottom: 10px;\r\n    line-height: 1.4;\r\n}\r\n\r\n.kpi-usage-tooltip-subtitle {\r\n    font-size: 11px;\r\n    color: rgba(255, 255, 255, 0.6);\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.kpi-usage-tooltip-row {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    margin-bottom: 7px;\r\n}\r\n\r\n.kpi-usage-tooltip-row:last-child {\r\n    margin-bottom: 0;\r\n}\r\n\r\n.kpi-usage-tooltip-name {\r\n    font-size: 13px;\r\n    font-weight: 500;\r\n    color: #fff;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    max-width: 110px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.kpi-usage-tooltip-bar-track {\r\n    flex: 1;\r\n    height: 6px;\r\n    background-color: rgba(255, 255, 255, 0.25);\r\n    border-radius: 3px;\r\n    overflow: hidden;\r\n    min-width: 50px;\r\n}\r\n\r\n.kpi-usage-tooltip-bar-fill {\r\n    height: 100%;\r\n    background-color: #fff;\r\n    border-radius: 3px;\r\n    transition: width 0.4s ease;\r\n}\r\n\r\n.kpi-usage-tooltip-bar-full {\r\n    background-color: #ef4444;\r\n}\r\n\r\n.kpi-usage-tooltip-values {\r\n    font-size: 12px;\r\n    color: rgba(255, 255, 255, 0.85);\r\n    white-space: nowrap;\r\n    flex-shrink: 0;\r\n    text-align: right;\r\n    min-width: 40px;\r\n    margin-left: auto;\r\n}\r\n\r\n.charts-parent-container {\r\n    display: flex;\r\n    width: 100%;\r\n    gap: 20px;\r\n    margin-top: 20px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.charts-container {\r\n    width: 49.5%;\r\n}\r\n\r\n.charts-title {\r\n    color: #5616ea;\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.charts-graph {\r\n    background-color: rgb(255, 255, 255);\r\n    border-radius: 10px;\r\n    padding: 12px;\r\n    height: 350px;\r\n    border: 1px solid #e5e7eb;\r\n}\r\n\r\n.chat-interface-container {\r\n    display: flex;\r\n    width: 100%;\r\n    height: 750px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 10px;\r\n    overflow: hidden;\r\n}\r\n\r\n.chat-list-container {\r\n    width: 30%;\r\n    max-width: 350px;\r\n    min-width: 200px;\r\n    background-color: #f5f5f5;\r\n    overflow-y: auto;\r\n    border-right: 1px solid #ddd;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n/* For Webkit Browsers (Chrome, Safari, Edge) */\r\n.chat-list-container::-webkit-scrollbar {\r\n    width: 8px;\r\n}\r\n\r\n.chat-list-container::-webkit-scrollbar-track {\r\n    background: #f5f5f5;\r\n    border-radius: 4px;\r\n}\r\n\r\n.chat-list-container::-webkit-scrollbar-thumb {\r\n    background: #bbb;\r\n    border-radius: 4px;\r\n}\r\n\r\n.chat-list-container::-webkit-scrollbar-thumb:hover {\r\n    background: #999;\r\n}\r\n\r\n/* For Firefox */\r\n.chat-list-container {\r\n    scrollbar-width: thin;\r\n    scrollbar-color: #bbb #f5f5f5;\r\n}\r\n\r\n.chat-list-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.chat-list-last-message {\r\n    margin-top: 5px;\r\n    font-size: 14px;\r\n    color: #666;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n.chat-session.selected .chat-list-last-message {\r\n    color: #ffffff;\r\n}\r\n\r\n.chat-session {\r\n    padding: 10px;\r\n    padding-top: 15px;\r\n    padding-bottom: 15px;\r\n    cursor: pointer;\r\n    border-bottom: 1px solid #ddd;\r\n    background-color: rgb(252, 252, 252);\r\n    transition: background-color 0.2s ease;\r\n}\r\n\r\n.chat-session:hover {\r\n    background-color: #e0e0e0;\r\n}\r\n\r\n.chat-session.selected {\r\n    background-color: #5616ea;\r\n    color: #ffffff;\r\n}\r\n\r\n.chat-history-container {\r\n    flex: 1;\r\n    padding: 15px;\r\n    padding-top: 20px;\r\n    padding-bottom: 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    background-color: #ffffff;\r\n    overflow-y: auto;\r\n}\r\n\r\n/* For Webkit Browsers (Chrome, Safari, Edge) */\r\n.chat-history-container::-webkit-scrollbar {\r\n    width: 8px;\r\n}\r\n\r\n.chat-history-container::-webkit-scrollbar-track {\r\n    background: #f5f5f5;\r\n    border-radius: 4px;\r\n}\r\n\r\n.chat-history-container::-webkit-scrollbar-thumb {\r\n    background: #bbb;\r\n    border-radius: 4px;\r\n}\r\n\r\n.chat-history-container::-webkit-scrollbar-thumb:hover {\r\n    background: #999;\r\n}\r\n\r\n/* For Firefox */\r\n.chat-history-container {\r\n    scrollbar-width: thin;\r\n    scrollbar-color: #bbb #f5f5f5;\r\n}\r\n\r\n\r\n.chat-history {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 15px;\r\n}\r\n\r\n.chat-message {\r\n    display: flex;\r\n}\r\n\r\n.user-message {\r\n    justify-content: flex-end;\r\n}\r\n\r\n.assistant-message {\r\n    justify-content: flex-start;\r\n}\r\n\r\n.message-bubble {\r\n    /* max-width: 70%; */\r\n    padding: 10px;\r\n    border-radius: 10px;\r\n    word-wrap: break-word;\r\n}\r\n\r\n.user-message .message-bubble {\r\n    background-color: #d1f0ff;\r\n}\r\n\r\n.no-chat-selected {\r\n    text-align: center;\r\n    color: #999;\r\n    font-size: 18px;\r\n    margin-top: auto;\r\n    margin-bottom: auto;\r\n}\r\n\r\n.download-header-parent {\r\n    display: flex;\r\n    flex-direction: row;\r\n    gap: 15px;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.charts-title-download {\r\n    color: #5616ea;\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n}\r\n\r\n.download-chat-history-btn {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    border-radius: 8px;\r\n    outline: none;\r\n    padding: 8px;\r\n    padding-top: 6px;\r\n    padding-bottom: 6px;\r\n    background-color: #5616ea;\r\n    border: none;\r\n    color: white;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease, transform 0.3s ease;\r\n    box-shadow: 0 4px 14px rgba(0,0,0,0.1);\r\n}\r\n\r\n.download-chat-history-btn:hover {\r\n    background-color: #4a14d6;\r\n    transform: translateY(-1px);\r\n}\r\n\r\n.download-chat-history-btn:disabled {\r\n    background-color: #c4c4c4;\r\n    cursor: not-allowed;\r\n    transform: none;\r\n    box-shadow: none;\r\n}\r\n\r\n.download-chat-history-icon {\r\n    font-size: 16px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .selection-container {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .kpi-container {\r\n        flex-wrap: wrap;\r\n        justify-content: center;\r\n    }\r\n\r\n    .kpi-container > * {\r\n        flex: 1 1 calc(50% - 10px);\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    .charts-parent-container {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .charts-container {\r\n        width: 100%;\r\n    }\r\n\r\n    .chat-list-container {\r\n        width: 30%;\r\n        max-width: 350px;\r\n        min-width: 160px;\r\n    }\r\n\r\n    .chat-interface-container {\r\n        height: 500px;\r\n    }\r\n\r\n    .charts-graph {\r\n        background-color: rgb(255, 255, 255);\r\n        border-radius: 10px;\r\n        padding: 5px;\r\n        height: 250px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
